'use strict';

export const DEVELOP = 'development';
export const STAGING = 'staging';
export const PRODUCTION = 'production';



// WEBPACK FOOTER //
// ./src/js/config/constants/environments.js